import { InfluxDB, Point, WriteApi } from '@influxdata/influxdb-client-browser';
import TokenService from '../../api_services/TokenService/TokenService';

class InfluxWriter {
  private token: string | null = null;
  private writeApi: WriteApi | null = null;

  constructor() {
    if (!Metrics.enabled) {
      console.log('Influx metrics disabled');
    }

    window.addEventListener('beforeunload', () => {
      this.writeApi?.flush();
    });
  }

  private setUpDefaultTags = () => {
    const { email } = TokenService.getUser()!;

    this.writeApi!.useDefaultTags({
      Environment: Metrics.environment,
      UserEmail: email,
    });
  };

  private getWriteApi = async () => {
    const { token } = TokenService.getAny() || (await TokenService.updateToken(null));

    if (token !== this.token) {
      this.token = token;

      if (this.writeApi) {
        const prevWriteApi = this.writeApi;

        // We will let old retries complete before closing the connection with the old token, e.g. in case there were network issues
        setTimeout(() => {
          prevWriteApi.close();
        }, 60000);
      }

      this.writeApi = new InfluxDB({
        transportOptions: {
          keepalive: true,
        },
        url: Metrics.influx.host,
        headers: {
          Authorization: `Bearer ${token}`,
        },
        timeout: 120000,
        writeOptions: {
          flushInterval: 15000,
          batchSize: 100,
        },
      }).getWriteApi(Metrics.influx.org, Metrics.influx.bucket);

      // @TODO Note that we might need to fix this later, because Nginx in front of InfluxDB is misconfigured.
      // We are actually sending v2 data to v1 endpoint (and it works by accident)
      this.writeApi.path = this.writeApi.path.replace('/api/v2/write', `/${Metrics.environment}/write`);

      this.setUpDefaultTags();
    }

    return this.writeApi;
  };

  send = async (measurementName: string, point: Point) => {
    if (!Metrics.enabled) {
      return;
    }

    const writeApi = (await this.getWriteApi())!;

    const fullMeasurementName = `${Metrics.componentName}/${measurementName}`;
    point.measurement(fullMeasurementName);

    writeApi.writePoint(point);
  };
}

export const influxWriter = new InfluxWriter();
